(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hubspot-deal', {
            parent: 'entity',
            url: '/hubspot-deal?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.hubspotDeal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hubspot-deal/hubspot-deals.html',
                    controller: 'HubspotDealController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hubspotDeal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('hubspot-deal-detail', {
            parent: 'entity',
            url: '/hubspot-deal/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.hubspotDeal.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hubspot-deal/hubspot-deal-detail.html',
                    controller: 'HubspotDealDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hubspotDeal');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HubspotDeal', function($stateParams, HubspotDeal) {
                    return HubspotDeal.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('hubspot-deal.new', {
            parent: 'hubspot-deal',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hubspot-deal/hubspot-deal-dialog.html',
                    controller: 'HubspotDealDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                deal_id: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('hubspot-deal', null, { reload: true });
                }, function() {
                    $state.go('hubspot-deal');
                });
            }]
        })
        .state('hubspot-deal.edit', {
            parent: 'hubspot-deal',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hubspot-deal/hubspot-deal-dialog.html',
                    controller: 'HubspotDealDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HubspotDeal', function(HubspotDeal) {
                            return HubspotDeal.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hubspot-deal', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hubspot-deal.delete', {
            parent: 'hubspot-deal',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hubspot-deal/hubspot-deal-delete-dialog.html',
                    controller: 'HubspotDealDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HubspotDeal', function(HubspotDeal) {
                            return HubspotDeal.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hubspot-deal', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
